/**
 * nou: PDP sold-out → Notify-me swap.
 *
 * The buy form and the "Notify me when available" box are both rendered inside
 * <nou-soldout-buy> (see blocks/buy-buttons.liquid). The initial visible surface
 * is decided server-side (nou_is_soldout). This element flips between them on
 * every variant change.
 *
 * "Sold out" = the selected size is out of stock for the selected colour
 * (inventory_quantity <= 0, any policy — the client rule is "any size at 0 stock").
 * That flag is computed server-side in variant-main-picker.liquid and carried on
 * the checked size radio as data-soldout, so we read it from the freshly-fetched
 * section HTML (event.detail.data.html) — the same source nou-inventory-status.js
 * uses — rather than guessing from variant.available (which stays true for oversold
 * pre-order sizes).
 */
(function () {
  if (customElements.get('nou-soldout-buy')) return;

  // The freshly-fetched section HTML marks the selected size radio with the
  // `checked` content attribute, so match that (not the dynamic :checked pseudo,
  // which isn't reliable on a detached/parsed document).
  function checkedSizeRadio(html) {
    return html ? html.querySelector('.variant-picker input[data-soldout][checked]') : null;
  }

  function isSoldOut(html, resource) {
    // Prefer the server-computed per-colour flag on the checked size radio.
    var checked = checkedSizeRadio(html);
    if (checked) return checked.dataset.soldout === 'true';
    // Fallback for size-only / default-variant products with no data-soldout radios.
    if (resource && typeof resource.available === 'boolean') return resource.available === false;
    return false;
  }

  customElements.define(
    'nou-soldout-buy',
    class extends HTMLElement {
      connectedCallback() {
        this._update = this._update.bind(this);
        // Match the theme's components: variant:update is dispatched on / bubbles to the section.
        this._section = this.closest('.shopify-section, dialog') || document;
        this._section.addEventListener('variant:update', this._update);
      }

      disconnectedCallback() {
        if (this._section) this._section.removeEventListener('variant:update', this._update);
      }

      _update(event) {
        var detail = event && event.detail;
        var data = detail && detail.data;
        if (!data) return;

        if (data.newProduct) {
          // Combined-listing colour switch — the product changed; adopt the new id.
          this.dataset.productId = data.newProduct.id;
        } else if (data.productId != null && String(data.productId) !== String(this.dataset.productId)) {
          // A different product's variant changed (e.g. a recommendation card) — ignore.
          return;
        }

        var buyArea = this.querySelector('.nou-buy-area');
        var notifyArea = this.querySelector('.nou-notify-area');
        if (!buyArea || !notifyArea) return;

        var resource = detail.resource;
        var soldOut = isSoldOut(data.html, resource);

        buyArea.hidden = soldOut;
        notifyArea.hidden = !soldOut;

        // Keep the Notify form's hidden Klaviyo fields in sync with the selected size.
        var variantInput = notifyArea.querySelector('[data-nou-notify-variant-id]');
        if (variantInput) variantInput.value = (resource && resource.id) || '';

        var sizeInput = notifyArea.querySelector('[data-nou-notify-size]');
        if (sizeInput) {
          var checked = checkedSizeRadio(data.html);
          sizeInput.value = checked ? checked.value : (resource && resource.title) || '';
        }
      }
    }
  );
})();
